import React, { useContext, useState } from 'react'
import { Form, Row, Col, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, NotifyContext, Loading } from '../Library'
import { createRental } from '../Network/Rental'
import { useHistory } from 'react-router-dom'
import DatePicker from "react-datepicker";
import dayjs from 'dayjs'
import './AddRental.css'

function AddTenant() {
    const oneYearAhead = new Date().setFullYear(new Date().getFullYear() + 1)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.tenant
    const notify = useContext(NotifyContext)
    const history = useHistory()

    const [isLoading, setLoading] = useState(false)
    const [location, setLocation] = useState("")
    const [floor, setFloor] = useState("")
    const [zone, setZone] = useState("")
    const [contractNo, setContractNo] = useState("")
    const [telephone, setTelephone] = useState("")
    const [detail, setDetail] = useState("")
    const [startLeaseDate, setStartLeaseDate] = useState(new Date())
    const [expiredDate, setExpiredDate] = useState(oneYearAhead)
    const [isError, setIsError] = useState(false)

    const onSubmit = () => {
        if(!location || !floor || !zone || !contractNo || !detail){
            setIsError(true)
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            return
        }

        setLoading(true)
        let startLease = dayjs(startLeaseDate).valueOf()
        let expiredLease = dayjs(expiredDate).valueOf()
        createRental(location, floor, zone, contractNo, telephone, detail, startLease, expiredLease,
            ()=>{
                notify.showNotify(lang.created_contract, lang.created_contract_desc, 0)
                setLoading(false)
                history.push("/rental")
            },
            (error)=>{
                notify.showNotify("Something Wrong", error.message, 2)
                setLoading(false)
            })
    }

    return (
        <div>
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.add_tenant} isShowBack backTo="/rental"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form 
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.tenant_area}</Form.Label>
                            <Form.Control
                            value={location}
                            onChange={(e)=>setLocation(e.target.value)}
                            isInvalid={isError && !location}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.floor}</Form.Label>
                            <Form.Control
                            value={floor}
                            onChange={(e)=>setFloor(e.target.value)}
                            isInvalid={isError && !floor}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.zone}</Form.Label>
                            <Form.Control
                            value={zone}
                            onChange={(e)=>setZone(e.target.value)}
                            isInvalid={isError && !zone}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.contract_no}</Form.Label>
                            <Form.Control
                            value={contractNo}
                            onChange={(e)=>setContractNo(e.target.value)}
                            isInvalid={isError && !contractNo}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.telephone}</Form.Label>
                            <Form.Control
                            value={telephone}
                            onChange={(e)=>setTelephone(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.detail}</Form.Label>
                            <Form.Control 
                            value={detail}
                            onChange={(e)=>setDetail(e.target.value)}
                            isInvalid={isError && !detail}
                            as="textarea"/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.rental_start_date}</Form.Label>
                            <DatePicker
                            className="form-control"
                            selected={startLeaseDate}
                            dateFormat="d MMMM yyyy"
                            onChange={(date)=>{
                                date.setHours(0, 0, 0)
                                setStartLeaseDate(date)
                            }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.expired_lease}</Form.Label>
                            <DatePicker
                            className="form-control"
                            selected={expiredDate}
                            dateFormat="d MMMM yyyy"
                            onChange={(date)=>{
                                date.setHours(23, 59, 0)
                                setExpiredDate(date)
                            }}
                            />
                        </Form.Group>
                        <hr/>
                        <Button type="submit">
                            {lang.add_tenant}
                        </Button>
                    </Form>
                </Col>
            </Row>
            
        </div>
    )
}

export default AddTenant
